import { render, staticRenderFns } from "./averageNumberOfServiceChart.vue?vue&type=template&id=56ff32cf&scoped=true&"
import script from "./averageNumberOfServiceChart.vue?vue&type=script&lang=js&"
export * from "./averageNumberOfServiceChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ff32cf",
  null
  
)

export default component.exports